import React from "react";
import Info from "../img/Info.svg";
import { useTranslation } from "react-i18next";

export default () => {
  const { t } = useTranslation(["consultations"]);

  return (
    <div
      style={{
        backgroundColor: "#FFFAF2",
        padding: 5,
        marginBottom: 10,
        marginTop: 10,
        fontWeight: "bold",
        display: "flex",
        flexDirection: "row",
        gap: 5,
      }}
    >
      <div>
        <img src={Info} alt="" width={40} />
      </div>
      <div>
        <p>{t("medicationDeliveryDisclaimerMessage")}</p>
      </div>
    </div>
  );
};
